import React from 'react'

export const ArrowIcon = () =>
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path d='M6 9L12 15L18 9' stroke='#525586' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>
